import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

export const Footer = props => {
  const { expanded } = props

  return (
    <footer className={`footer ${expanded ? 'expanded' : ''}`}>
      {expanded && (
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-">
              <ul>
                <li>
                  Acurus Pty Ltd, Level 26/150 Lonsdale Street, Melbourne VIC
                  3000
                </li>
              </ul>
            </div>

            <div className="col-sm-6 col-md-4">
              <div className="footer__wrap footer__wrap_split footer__wrap_split_menu_column">
                <h4>General</h4>

                <ul id="menu-footer-column-two">
                  <li>
                    <Link to="about-the-nbn">About the nbn™</Link>
                  </li>
                  <li>
                    <Link to="broadband-usage-guide">
                      Broadband Usage Guide
                    </Link>
                  </li>
                  <li>
                    <Link to="switching-to-officeworks">
                      Switching to Officeworks
                    </Link>
                  </li>
                  <li>
                    <Link to="hardware">Hardware</Link>
                  </li>
                  <li>
                    <Link to="speed-information-for-nbn">
                      Speed Information for nbn™
                    </Link>
                  </li>
                  <li>
                    <Link to="faq">FAQ</Link>
                  </li>
                  <li>
                    <Link to="contact">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-sm-6 col-md-4">
              <div className="footer__wrap footer__wrap_split footer__wrap_split_menu_column">
                <h4>Legal</h4>

                <ul id="menu-footer-column-two">
                  <li className="menu-item menu-what-you-need-to-know">
                    <Link to="what-you-need-to-know">
                      What you need to know
                    </Link>
                  </li>
                  <li>
                    <Link to="privacy-policy">Officeworks™ Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="hardware-warranty-policy">
                      Hardware &amp; Warranty Policy
                    </Link>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="/pdf/officeworks-Financial-Hardship-Policy.pdf"
                    >
                      Financial Hardship Policy
                    </a>
                  </li>
                  <li>
                    <Link to="standard-form-of-agreement">SFOA</Link>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="/pdf/officeworks-Complaints-Handling-Process.pdf"
                    >
                      Complaints
                    </a>
                  </li>
                  <li>
                    <Link to="speed-information-for-nbn">
                      Speed Information for nbn™
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      {!expanded && (
        <div className="container">
          <nav role="navigation">
            <ul>
              <li>
                <Link to="/legal">Legal</Link>
              </li>
              <li>
                <a href="/pdf/complaint-handling-policy.pdf" target="_blank">
                  Complaints
                </a>
              </li>
              <li>
                <a href="/pdf/financial-hardship-policy.pdf" target="_blank">
                  Financial Hardship Policy
                </a>
              </li>
              <li>
                <Link to="/faq">FAQs</Link>
              </li>
              {/* <li>
                <Link to="/outages">Outages</Link>
              </li> */}
            </ul>
          </nav>
          <p className="copyright">
            Superloop Ltd, Level 25, 150 Lonsdale St, Melbourne VIC 3000
          </p>
        </div>
      )}
    </footer>
  )
}

Footer.defaultProps = {
  expanded: false,
}

Footer.propTypes = {
  expanded: PropTypes.bool,
}
